import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export class TextFileValidators {

    public static textFormat(fileType: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let file: any = control.value;
            if (file === null) return null;
            let formats = fileType.split(',');
            if (formats.find((i) => i == file.type) == undefined)
                return {
                    invalidFileType: {
                        invalidFileType: true,
                        requiredType: fileType.split('text/').join(''),
                    },
                };
            return null;
        };
    }

    public static textExtension(fileType: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let file: any = control.value;
            if (file === null) return null;
            if (typeof file == 'string') return null;
            return !(file.name.split('.')[1].toLowerCase() === fileType) ? {
                invalidFileExtension: {
                    invalidFileExtension: true,
                    requiredType: '.' + fileType,
                },
            } : null;
        };
    }

    public static sizeCheck(fileSize: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let file: any = control.value;
            if (typeof file == 'string') return null;
            if (file != null) {
                if (+file.size > +fileSize)
                    //in MB
                    return {
                        invalidFileSize: {
                            invalidFileSize: true,
                            requiredSize: +fileSize,
                        },
                    };
            }
            return null;
        };
    }
}